export const mergeTimeRange = (timeRangeArr1, timeRangeArr2) => {
  const stack = []
  let ranges = timeRangeArr1.concat(timeRangeArr2)
  ranges = ranges.sort((i1, i2) => i1.start - i2.start)
  // console.log("ranges sorted: ", JSON.stringify(ranges));
  stack.push(ranges[0])
  for (let i = 1; i < ranges.length; i++) {
    const top = stack[stack.length - 1]
    const iRange = ranges[i]
    if (top.end < iRange.start) {
      stack.push(iRange)
    } else if (top.end < iRange.end) { //and iRange.start <= top.end
      top.end = iRange.end
      stack.pop()
      stack.push(top)
    }
    // console.log('end of i: ', i, 'stack: ', JSON.stringify(stack))
  }
  // console.log('mergeTimeRange Input1: ', JSON.stringify(timeRangeArr1), ' Input2: ', JSON.stringify(timeRangeArr2), ' Output: ', JSON.stringify(stack))
  return stack
}

// const testMergeTimeRange = () => {
//   const mergedRanges = mergeTimeRange(
//     [
//       { start: 1, end: 5 },
//       { start: 5, end: 6 },
//       { start: 2, end: 7 },
//       { start: 8, end: 10 }
//     ],
//     [
//       { start: 8, end: 12 },
//       { start: 12, end: 18 },
//       { start: 13, end: 20 }
//     ]
//   )
//   console.log(mergedRanges) // equals [{"start":1,"end":7},{"start":8,"end":20}]
// }


export const convertTimeRangeToArray = timeRange => {
  const timeRangeArray = []
  for (let i = 0; i < timeRange.length; i++) {
    timeRangeArray.push({start: Math.ceil(timeRange.start(i)), end: Math.ceil(timeRange.end(i))})
  }
  return timeRangeArray
}

export const calculatePlayedTime = (timeRangeArr, duration) => {
  if (isNaN(duration) || duration === 0 || !isFinite(duration)) return 0
  let playedTime = 0
  for (let i = 0; i < timeRangeArr.length; i++) {
    const startX = timeRangeArr[i].start
    const endX = timeRangeArr[i].end
    playedTime += endX - startX
  }
  if (playedTime / duration * 100 > 100)  // may get bigger cause we ceil our buffer played times
  playedTime = Math.min(playedTime / duration * 100, 100)
  return isNaN(playedTime) || !isFinite(playedTime) ? 0 : playedTime // isNaN if we don't know duration
}
